import { Caravan, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCart } from "@/contexts/CartContext";
import { showInfoToast } from "@/lib/toast-utils";
import { useNavigate } from "react-router-dom";

export function UnitIndicator() {
  const { cart, updateCartName, refreshCart } = useCart();
  
  const navigate = useNavigate();

  // Parse VIN from cart name (format: "VIN: 1K52KBK28A2025661 (Jayco, Jay Flight, 2025)")
  const vinMatch = cart?.name?.match(/^VIN:\s*([^\s]+)\s*\(([^,]+),\s*([^,]+),\s*(\d+)\)$/);
  
  if (!vinMatch) return null;

  const [_, vin, make, model, year] = vinMatch;

  const handleRemoveVIN = async () => {
    if (cart?.secretId) {
      const success = await updateCartName(cart.secretId, "Stock Order");
      if (success) {
        await refreshCart();
        showInfoToast("This order is now a stock order.", "VIN Removed");
      }
    }
  };

  return (
    <div className="border-b border-border bg-primary/5 min-w-fit">
      <div className="container mx-auto px-3 md:px-6 py-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-primary/10 border border-primary/20">
              <Caravan className="h-3.5 w-3.5 text-primary" />
              <span className="text-xs font-medium text-primary">VIN Order</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-sm">
              <span 
                className="font-medium text-foreground hover:text-primary cursor-pointer transition-colors underline decoration-dotted underline-offset-4 hover:decoration-solid"
                onClick={() => navigate(`/units/${vin}`)}
                title="View VIN details"
              >
                {vin}
              </span>
              <span className="hidden sm:inline text-muted-foreground">•</span>
              <span className="text-muted-foreground">
                {make} {model} {year}
              </span>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleRemoveVIN}
            className="h-8 text-muted-foreground hover:text-foreground"
          >
            <X className="h-4 w-4 mr-1" />
            <span className="hidden sm:inline">Remove VIN</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
